import React from "react"
import RtlSvg from "@myvp/shared/src/icons/rtl-svg"
import {
  type IconProps,
  getIconViewBox,
  iconColorCss,
  iconSizeCss,
} from "@myvp/shared/src/styles/icon-utils"
import { css } from "@emotion/react"

type Variant = "right" | "left" | "down" | "up"
interface ChevronProps extends IconProps {
  variant?: Variant
}

const chevronCss = (variant?: Variant) => {
  let transform
  switch (variant) {
    case "left":
      transform = "rotate(180deg)"
      break
    case "up":
      transform = "rotate(270deg)"
      break
    case "down":
      transform = "rotate(90deg)"
      break
    case "right":
    default:
      return
  }

  // Apply transform to 'g' element to avoid incorrect focus outlines on ios safari
  return css`
    > g {
      transform: ${transform};
      transform-origin: center;
    }
  `
}

const Chevron = (props: ChevronProps) => {
  const color = props.color ?? "default"
  const size = props.size ?? "medium"
  const variant = props.variant ?? "right"

  let children
  switch (size) {
    case "small":
      children = (
        <path
          d="M6 12.001L10 8.00098L6 4.00098"
          strokeWidth="1.5"
          strokeOpacity="1"
          stroke="var(--color)"
        />
      )
      break
    case "medium":
      children = (
        <path
          d="M9 18L15 12L9 6"
          strokeWidth="2"
          strokeOpacity="1"
          stroke="var(--color)"
        />
      )
      break
    case "large":
      children = (
        <path
          d="M12 24L20 16L12 8"
          strokeWidth="2"
          strokeOpacity="1"
          stroke="var(--color)"
        />
      )
      break
  }

  return (
    <RtlSvg
      className={props.className}
      focusable="false"
      viewBox={getIconViewBox(size)}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      css={[iconSizeCss(size), iconColorCss(color), chevronCss(variant)]}
    >
      <g>{children}</g>
    </RtlSvg>
  )
}

export default Chevron
